import React from "react";
import { Box, Typography } from "@mui/material";
import { colors, spacing, typography } from "../../theme/tokens";

interface SectionTitleProps {
  en: string;
  ja: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ en, ja }) => {
  return (
    <Box sx={{ textAlign: "center", mb: spacing[600] }}>
      <Typography
        variant="h2"
        sx={{
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: "-12px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "60px",
            height: "2px",
            background: colors.primary[600],
          },
        }}
      >
        {en}
      </Typography>
      <Typography
        sx={{
          mt: spacing[400],
          fontSize: typography.fontSize.sm,
          color: colors.neutral[500],
          letterSpacing: typography.letterSpacing.wider,
        }}
      >
        {ja}
      </Typography>
    </Box>
  );
};
